// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountHomepageSelectorStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountHomepageSelector";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

myAccountHomepageSelectorStyles.checkboxGroup = {
    css: css`
        align-items: flex-end;
        height: 100%;
        justify-content: center;
        ${xScreen("lte", "xs")} {
            align-items: flex-start;
        }
    `,
};
